import { Button, Text } from '@kanda-libs/ks-design-library';
import NumberedList from 'components/shared/NumberedList';
import TrustpilotBar from 'components/shared/TrustpilotBar';
import { replaceTradingName } from '../helpers';
import { COPY, LIST } from './constants';

export interface EnquiryWelcomeContentProps {
  onClick: () => void;
  tradingName: string;
  isLoading?: boolean;
}

const EnquiryWelcomeContent: React.FunctionComponent<EnquiryWelcomeContentProps> =
  function ({ onClick, tradingName, isLoading = false }) {
    return (
      <div className="flex flex-col gap-y-4 md:gap-y-6 w-full mb-auto pt-3">
        <Text
          text={
            <h1 className="text-20-24-em md:text-24-28-em text-left">
              {replaceTradingName(COPY.header, tradingName)}
            </h1>
          }
          isLoading={isLoading}
          skeletonProps={{
            height: 28,
          }}
        />
        <Text
          text={
            <h2 className="text-14-22 md:text-16-24 text-left">
              {replaceTradingName(COPY.body, tradingName)}
            </h2>
          }
          isLoading={isLoading}
          skeletonProps={{
            count: 4,
          }}
        />
        <NumberedList
          list={LIST.map((item) => ({
            ...item,
            content: replaceTradingName(item.content, tradingName),
          }))}
          headerTextClassName="text-14-22-em md:text-16-24-em text-neutral-700"
          contentTextClassName="text-14-22 text-neutral-700"
          isLoading={isLoading}
        />
        <Button.Text
          id="enquiry-apply-start"
          label="Start Your Journey"
          icon="arrow-right"
          variant="gradient"
          onClick={onClick}
          className="mt-2"
          disabled={isLoading}
        />
        <TrustpilotBar wrapperClassName="mb-6" />
      </div>
    );
  };

export default EnquiryWelcomeContent;
